import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apexOne = defineConnector({
  identifier: "apexOne",
  name: "Apex One",
  tagLine: "Endpoint security (Trend Micro Apex Central)",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ serverAddress }) =>
    serverAddress
      ? `${serverAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/.*`
      : "https://.*/.*",
  auth: customAuth("apexOne"),
  steps: [
    {
      title: "Create an application in Apex Central",
      items: [
        {
          kind: "markdown",
          content:
            "In Apex Central, open **Administration → Settings → Automation API Access Settings**, add a new application, and copy the **Application ID** and **API key**.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "Server address",
          placeholder: "https://apex.example.com",
          required: true,
          target: { kind: "configuration", field: "serverAddress" },
          helperText: "The base URL of your Apex Central server.",
        },
        {
          kind: "input",
          label: "Application ID",
          required: true,
          target: { kind: "configuration", field: "applicationId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverAddress }) =>
      `${(serverAddress ?? "").replace(/\/$/, "")}/WebApp/API/ServerResource/ProductServers`,
  },
});
